import React, { Component } from 'react';
import './Component.css';
import MetropolitanBubbleChart from './MetropolitanBubbleChart';
import { interpolateViridis } from 'd3';
import ReadMore from './ReadMore/ReadMore.jsx';
import { getText } from './AllTexts.jsx';

class TemporalChange extends Component {
	render() {
		let maxRadius = 90;
		if (this.props.width < 1200) {
		  maxRadius = Math.pow(this.props.width/1200, 0.9) * 90;
		}

		let text;

		if (this.props.city === "vancouver") {
			text = getText('scale-bubble-intro-vancouver');
		} else if (this.props.city === "toronto") {
			text = getText('scale-bubble-intro-toronto');
		}

		return (
			<div className="Scale-Bubble Component" id="bubble">
				<div className="text">
					{text}
				</div>
				<div className="graphic">
					<MetropolitanBubbleChart
					title=""
					height='700'
					xValue={d => getText(d.origin.trim())}
					yValue={d => getText(d.category)}
					innerRadiusValue={d => d.value}
					outerRadiusValue={d => d.total}
					colorValue={d => d.value / d.total}
					margin={{ top: 150, right: 150, bottom: 230, left: 250 }}
					maxRadius={maxRadius}
					xAxisOffset={85}
					yAxisOffset={80}
					titleOffset={-80}
					backLayerCircleColor='rgba(255,255,255,1.0)'
					colorScheme={interpolateViridis}
					filter={this.props.params.filter}
					update={this.props.update}
					width={this.props.width}
					city={this.props.city}
					/>
				</div>
		  </div>
		);
	}
}

export default TemporalChange;



// WEBPACK FOOTER //
// ./src/ScaleBubble.jsx